import React from 'react'
import Cards from './Cards'
//import Client from '../Client/Client'


function Dashboard() {
  return (
  
    <>
    <Cards/>

    </>
  )
}

export default Dashboard